export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_00.081883e0.jpg";